
import Component from 'vue-class-component'
import Vue from 'vue'
import TemplateDesign from '../components/template-design/TemplateDesign.vue'

/**
 * 웹파트 페이지 템플릿 구성
 * 템플릿의 디자이너 레이아웃에 웹파트를 배치하고 구성하는 화면
 */
@Component({
    components: { TemplateDesign },
})
export default class TemplateDesignView extends Vue {}
